module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "reservation-modal editReservationModal payment dark-top",
    attrs: {
      "dialog": "modal-wide",
      "customClass": "heightAuto",
      "footer": false
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.reservation) ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center mb-1"
  }, [_c('h2', {
    staticClass: "m-0"
  }, [_vm._v(_vm._s(_vm.headerLine1))]), _vm._v(" "), _c('change-status-btn', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.getIsSavingReservation || _vm.accessPermissionFilter(['restricted'])
    },
    model: {
      value: (_vm.reservation),
      callback: function($$v) {
        _vm.reservation = $$v
      },
      expression: "reservation"
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "mb-1 light"
  }, [_vm._v(_vm._s(_vm.headerLine2))]), _vm._v(" "), (_vm.reservation.linkedBookings && _vm.reservation.linkedBookings.length > 0) ? _c('div', [_c('span', {
    staticClass: "light mr-1 font-weight-400"
  }, [_vm._v("Related bookings:")]), _vm._v(" "), _vm._l((_vm.reservation.linkedBookings), function(linkedBooking) {
    return _c('span', {
      staticClass: "pointer bg-color-1 px-1 radius-normal border-dark fs-small",
      on: {
        "click": function($event) {
          return _vm.clickShoppinigCartOtherReservation(linkedBooking)
        }
      }
    }, [_vm._v("#" + _vm._s(linkedBooking))])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column bg-lighter position-relative",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.showPrebookOverlay) ? _c('prebook-overlay') : _c('div', [(_vm.showCreateInvoiceModal) ? _c('create-invoice-modal', {
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "close": _vm.toggleCreateInvoiceModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddPayment) ? _c('add-payment', {
    attrs: {
      "reservation": _vm.reservation,
      "showAddPayment": _vm.showAddPayment
    },
    on: {
      "toggleAddPayment": _vm.toggleAddPayment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditExtras) ? _c('edit-extras', {
    attrs: {
      "reservation": _vm.reservation,
      "showAddPayment": _vm.showAddPayment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddExtras) ? _c('add-extras', {
    attrs: {
      "reservation": _vm.reservation
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditTransport) ? _c('edit-transport', {
    attrs: {
      "reservation": _vm.reservation,
      "showAddPayment": _vm.showAddPayment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showInvoiceModal) ? _c('invoice-modal', {
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "toggleInvoiceModal": _vm.toggleInvoiceModal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unsavedChanges bg-color-1 lightest text-center",
    class: {
      'active': _vm.reservationHasUnsavedChanges
    }
  }, [_vm._v("\n            Don't forget to "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Save Changes")]), _vm._v(".\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(!_vm.reservation) ? _c('div', {
    staticClass: "col-sm-10 text-center dark fs-larger p-5"
  }, [_vm._v("\n                    Grab a coffe while we are loading ☕️\n                ")]) : _c('div', {
    staticClass: "col-sm-10"
  }, [_c('top-area', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.getIsSavingReservation,
      "reservation": _vm.reservation
    }
  }), _vm._v(" "), _c('tabs', {
    staticClass: "tabsEditReservation"
  }, [_c('tab', {
    attrs: {
      "name": "CUSTOMER DETAILS"
    }
  }, [_c('tab-details', {
    attrs: {
      "disabled": _vm.getIsSavingReservation,
      "reservation": _vm.reservation
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "BILLING"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 mt-2"
  }, [(_vm.getShowInvoiceOption) ? _c('div', {
    staticClass: "col-sm-12 d-flex panel p-0 pb-2 border-top-lightest border-left-lightest border-right-lightest justify-content-end"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "disabled": _vm.getIsSavingReservation
    },
    on: {
      "click": _vm.startCreateInvoice
    }
  }, [_vm._v("Create Invoice")])]) : _vm._e(), _vm._v(" "), (_vm.reservation.bookingInvoices && _vm.reservation.bookingInvoices.length > 0) ? _c('div', {
    staticClass: "invoiceListHolder mb-3 panel p-0 border-top-lightest"
  }, [_c('invoice-list', {
    attrs: {
      "invoiceList": _vm.reservation.bookingInvoices
    },
    on: {
      "toggleInvoiceModal": _vm.toggleInvoiceModal
    }
  })], 1) : (_vm.getShowInvoiceOption) ? _c('div', {
    staticClass: "dark fs-large text-center m-5 mt-5"
  }, [_vm._v("It seems you have no invoices.\n                                ")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "mt-4 bold fs-normal"
  }, [_vm._v("BILLING DETAILS")]), _vm._v(" "), _c('tab-billing-details', {
    attrs: {
      "reservation": _vm.reservation,
      "readOnly": _vm.isReservationReadOnly || _vm.getIsSavingReservation,
      "showInvoiceBtn": false
    }
  })], 1)]), _vm._v(" "), (_vm.featureFlags.showRefunds) ? _c('tab', {
    attrs: {
      "name": "REFUNDS"
    }
  }, [_c('tab-refunds', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 pl-0"
  }, [_c('side-buttons', {
    attrs: {
      "disabled": _vm.getIsSavingReservation,
      "reservation": _vm.reservation,
      "showAddPayment": _vm.showAddPayment
    },
    on: {
      "toggleAddPayment": _vm.toggleAddPayment,
      "updateReservationsList": _vm.reservationUpdated,
      "updateThisReservation": _vm.updateThisReservation
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f300fd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit.vue
// module id = 1682
// module chunks = 0